<template>
  <v-dialog v-model="show" width="500px">
    <v-card class="mt-2">
      <v-card-title>受入上限本数設定</v-card-title>
      <v-card-actions>
        <v-btn :disabled="!upperLimit && upperLimit !== 0" @click="save"
          >適用更新</v-btn
        >
        <v-btn @click="back">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form>
        <v-card-text v-if="!isSetingOneDay">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md6>
                <date-picker
                  label="適用期間"
                  :min="today"
                  v-model="period.start"
                />
              </v-flex>
              <v-flex md6>
                <date-picker
                  :min="period.start"
                  :max="maxDate"
                  v-model="period.end"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex>
                <v-layout align-center>
                  <v-checkbox
                    :key="week"
                    :label="week"
                    :value="index"
                    class="shrink mr-2"
                    hide-details
                    v-for="(week, index) in $t('app.weekdays')"
                    v-model="workDay"
                  />
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <v-layout>
              <v-flex>
                <v-text-field
                  clearable
                  label="受入上限本数"
                  suffix="本"
                  type="number"
                  v-model.number="upperLimit"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import DateFormat from 'dateformat'

export default {
  data() {
    return {
      show: false,
      upperLimit: 9,
      period: { start: '2018-12-21', end: '2018-12-21' },
      workDay: [],
      isSetingOneDay: false,
      resolve: null,
      reject: null,
      today: null,
    }
  },
  methods: {
    popup(params) {
      this.today = DateFormat(new Date(), 'yyyy-mm-dd')
      if (params) {
        this.isSetingOneDay = true
        let date = DateFormat(params.date, 'yyyy-mm-dd')
        this.period = { start: date, end: date }
        this.upperLimit = params.upperLimit
        this.workDay = [params.date.getDay()]
      } else {
        this.isSetingOneDay = false
        let date = DateFormat(new Date(), 'yyyy-mm-dd')
        this.period = { start: date, end: date }
        this.upperLimit = null
        this.workDay = []
      }
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    save() {
      this.show = false
      let start = new Date(this.period.start)
      let end = new Date(this.period.end)
      let result = {}
      for (let i = start; i <= end; i.setDate(i.getDate() + 1)) {
        if (
          this.workDay.length > 0 &&
          this.workDay.indexOf(i.getDay()) === -1
        ) {
          continue
        }
        if (this.upperLimit === null) {
          result[DateFormat(i, 'yyyy-mm-dd')] = null
        } else {
          result[DateFormat(i, 'yyyy-mm-dd')] = this.upperLimit
        }
      }
      this.resolve(result)
      this.workDay = []
      this.period = {}
      this.upperLimit = null
    },
    back() {
      this.show = false
    },
  },
  computed: {
    maxDate() {
      var today = new Date()

      var dayAfterOneYear = new Date(today.getTime() + 24 * 3600 * 1000 * 365)

      return DateFormat(dayAfterOneYear, 'yyyy-mm-dd')
    },
  },
}
</script>
